import React from 'react';
import {LazyImage} from "../../../Components";
import {detectEnglishLang} from "../../../Services";
import {Col, Row} from "antd";

function TriadBigRightDesktop({item,right,right_bottom,right_top,LinkDispatcher}){



    return(
        <Row gutter={[16,4]} justify="center"  className="component-row">
            <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18}} >
                <div className="block-container">
                    {item.title?<div className="section-title"><span>{item.title}</span></div>:null}
                    {right?.image_desktop ? <div className={`block-pool ${item.has_shadow?"shadow-sec":""}`}
                                                 style={{order: 1}}>
                        <div className="block-item-vertical">
                            <div className="wrapper"
                                 onClick={() => LinkDispatcher(right_top.link_to, right_top)}>
                                <img className="max-height" src={right_top.image_desktop} alt=""/>
                                <span className="block-title">{right_top.title}</span>
                            </div>
                            <div className="wrapper"
                                 onClick={() => LinkDispatcher(right_bottom.link_to, right_bottom)}>
                                <img className="max-height" src={right_bottom.image_desktop} alt=""/>
                                <span className="block-title">{right_bottom.title}</span>
                            </div>
                        </div>
                        <div className="block-item-vertical">
                            <div className="wrapper"
                                 onClick={() => LinkDispatcher(right.link_to, right)}>
                                <img src={right.image_desktop} alt=""/>
                                <span className="block-title">{right.title}</span>
                            </div>
                        </div>
                    </div> : null}
                </div>
            </Col>
        </Row>
    )
}

export default TriadBigRightDesktop
